export const loadTypes = {
  any: null,
  ltl: true,
  ftl: false,
};
